import { useCallback } from 'react';
import { SelectableChip } from '@aimsos/ui';

/**
 * SelectableChip that reports a `value` to `onSelect`, so parent maps do not
 * allocate a new arrow per option on every render.
 */
function ValueSelectableChip({ value, onSelect, ...chipProps }) {
  const handleClick = useCallback(() => {
    onSelect(value);
  }, [onSelect, value]);

  return <SelectableChip {...chipProps} onClick={handleClick} />;
}

export default ValueSelectableChip;
